import type { TableRequest } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { auditStore } from '@stores/auditStore';
import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';

import type { AppAuditDto } from '../api';

export const getExcelWithAudit =
  (
    message: string,
    audit: AppAuditDto = {
      // по умолчанию стоит для скачивания справочников
      moduleName: 'Calculator',
      serviceName: 'Reference_book',
      operationName: 'Download_reference_book',
    },
  ) =>
  async (tableInfo: TableRequest): Promise<void> => {
    const response = await ksnmTableStore.getExcelStreamV2(tableInfo);

    if (response.status === 200) {
      auditStore.createAuditData({
        ...audit,
        message,
      });
    }

    return response;
  };
